<div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid">
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-portlet__body">
      <div class="kt-form kt-form--label-right  mb-2">
        <div class="row align-items-center">
          <div class="col-xl-12 order-2 order-xl-1 pr-0">
            <form class="row align-items-center" [formGroup]="form">
              <!-- First Row -->
              <div class="col-12 row mb-2 pr-0">
                <!-- Username -->
                <div class="col-md-1 kt-form__label col-form-label">
                    <label>Username:</label>
                </div>
                <div class="col-md-2 kt-form__control">
                    <input type="text" formControlName="username" placeholder="Search" class="form-control">
                </div>
                <!-- Smartico ID -->
                <div class="col-md-1 kt-form__label col-form-label">
                    <label>Smartico ID:</label>
                </div>
                <div class="col-md-2 kt-form__control">
                    <input type="text" formControlName="smartico_id" placeholder="Search" class="form-control">
                </div>
                <!-- Promotion -->
                <div class="col-md-1 kt-form__label col-form-label">
                    <label>Promotion:</label>
                </div>
                <div class="col-md-4 kt-form__control">
                    <input type="text" formControlName="promotion" placeholder="{{ 'Search' | translate }}" class="form-control" [ngbTypeahead]="this.searchPromo" [resultFormatter]="this.formatPromo" [inputFormatter]="this.formatPromo">
                </div>
              </div>
              <!-- Second Row -->
              <div class="col-12 row mb-2 pr-0">
                <!-- Date Time -->
                <div class="col-md-1 kt-form__label col-form-label">
                    <label>Date/Time:</label>
                </div>
                <div class="col-md-5 kt-form__control">
                    <div class="input-group date">
                        <!-- <div class="input-group-prepend">
                            <select formControlName="date_type" class="form-control">
                                <option [value]="item.key" *ngFor="let item of dateTimeFilterType">{{ item.label }}</option>
                            </select>
                        </div> -->
                        <input type="text" class="form-control" placeholder="Search" (change)="onDateRange($event)" [formControl]="form.controls['defaultDate']" [timePicker]="true" [timePickerSeconds]="true" [opens]="'left'"  [alwaysShowCalendars]="true" [ranges]="ranges" [showCustomRangeLabel]="true" [locale]="{format: 'YYYY-MM-DD HH:mm:ss'}" [timePicker24Hour]="true" [showDropdowns]="true" (click)="updateDateRange()" ngxDaterangepickerMd />
                        <span class="input-group-append">
                            <span class="input-group-text pointer-calendar" (click)="onClearDate()">X</span>
                        </span>
                    </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- Action Button -->
      <div class="kt-section col-12 row d-flex justify-content-between mb-3 mt-2">
          <div class="dropdown dropdown-inline">
              <kt-search-button [loading]="searchBtnLoading" [disabledButton]="loading" (search)="onSubmit()"></kt-search-button>
              <kt-clear-button [loading]="clearBtnLoading" [disabledButton]="loading" (clear)="onClear()"></kt-clear-button>
          </div>
      </div>
      <!-- Table -->
      <div class="kt-section">
        <div class="kt-section__content">
            <div class="table-responsive">
                <table class="table table-bordered table-hover table-striped table-sortable">
                    <thead>
                        <tr>
                            <th class="sort-enabled" (click)="onSortColumn('id')" [ngClass]="sortingConfig.id" [class.sort-selected]="sortingSelection.sort_by === 'id'">ID</th>
                            <th class="sort-enabled" (click)="onSortColumn('username')" [ngClass]="sortingConfig.username" [class.sort-selected]="sortingSelection.sort_by === 'username'">Username</th>
                            <th class="sort-enabled text-center" (click)="onSortColumn('promo_code')" [ngClass]="sortingConfig.promo_code" [class.sort-selected]="sortingSelection.sort_by === 'promo_code'">Reward</th>
                            <th class="sort-enabled" (click)="onSortColumn('smartico_bonus_id')" [ngClass]="sortingConfig.smartico_bonus_id" [class.sort-selected]="sortingSelection.sort_by === 'smartico_bonus_id'">Smartico ID</th>
                            <th class="text-center">Remarks</th>
                            <th class="text-right sort-enabled" (click)="onSortColumn('created_at')" [ngClass]="sortingConfig.created_at" [class.sort-selected]="sortingSelection.sort_by === 'created_at'">Created At</th>
                            <th class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="(logs$ | async) as rows">
                      <tr *ngFor="let row of rows">
                        <td> {{ row.id }} </td>
                        <td><a [ngClass]="row.referrer_dummy == 1 ? 'text-dummy-clickable' : 'text-primary'" class="font-weight-bold" (click)="onOpenDialog('member-information', row.member_account_id)">{{ row.member_account_username }}</a></td>
                        <td class="text-center">
                          <strong>{{ row.promotion_code }}</strong>
                          <ng-container *ngIf="row.reward_id !== null && row.reward_id !== 0">
                            <br/>
                            {{ row.currency_code }} {{ row.reward_credit | number:'1.2-2' }} 
                            <ng-container *ngIf="row.reward_status == 1">
                              {{ 'Claimed on' | translate }} {{ row.reward_claimed_at | timezoneDate: 'YYYY-MM-DD HH:mm' }}
                            </ng-container>
                            <ng-container *ngIf="row.reward_status == 2">
                              {{ 'Expired on' | translate }} {{ row.reward_expiry_datetime | timezoneDate: 'YYYY-MM-DD HH:mm' }}
                            </ng-container>
                            <ng-container *ngIf="row.reward_status == 3">
                              {{ 'Cancelled on' | translate }} {{ row.reward_updated_at | timezoneDate: 'YYYY-MM-DD HH:mm' }}
                            </ng-container>
                            <ng-container *ngIf="![1,2,3].includes(row.reward_status)">
                              {{ statuses[row.reward_status] }}
                            </ng-container>
                          </ng-container>
                        </td>
                        <td>{{ row.smartico_bonus_id }}</td>
                        <td class="text-center">
                          <strong>Additional Request Info:</strong>
                          <br/>
                          {{ row.request_detail }}
                          <br/>
                          <br/>
                          <strong>Results:</strong>
                          <br/>
                          {{ row.remarks }}
                        </td>
                        <td>{{ row.created_at | timezoneDate: 'YYYY-MM-DD HH:mm' }}</td>
                        <td class="text-center">
                          <button *ngIf="canAccessLinkedMemberPromo" matTooltip="Link To Promotion" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm" (click)="linkPromotion(row.promotion_id)"><i class="fa fa-gift"></i></button>
                        </td>
                      </tr>
                    </tbody>
                    <tbody shared-table-handler [loading]="loading" [dataLength]="dataLength" class="text-gray-600 fw-bold"></tbody>
                </table>
            </div>
            <div class="kt-pagination kt-pagination--brand mt-2" *ngIf="pagination !== undefined">
                <ngb-pagination
                  [pageSize]="pageSize"
                  [(page)]="page"
                  [maxSize]="maxSize"
                  [directionLinks]="true"
                  [boundaryLinks]="true"
                  [rotate]="true"
                  [collectionSize]="pagination.total"
                  (pageChange)="onViewPageBy(page)">
                </ngb-pagination>
                <div class="kt-pagination__toolbar">
                    <select (change)="onPerPage($event)" [(ngModel)]="pageSize" class="form-control kt-font-brand page-size">
                        <option [value]="item" *ngFor="let item of dropdown.perPage">{{ item }}</option>
                    </select>
                    <span class="pagination__desc">
                      Showing {{pagination.from}} to {{pagination.to}} of {{ pagination.total | number : '1.0' }} records
                    </span>
                </div>
              </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- message for permission error -->
<kt-swal-alert [message]="messages2$ | async" [icon]="'error'"></kt-swal-alert>
<kt-swal-alert [message]="messages$ | async"></kt-swal-alert>